import { render, staticRenderFns } from "./GmbServicesPreview.vue?vue&type=template&id=947cd7b6&scoped=true&"
import script from "./GmbServicesPreview.vue?vue&type=script&lang=js&"
export * from "./GmbServicesPreview.vue?vue&type=script&lang=js&"
import style0 from "./GmbServicesPreview.vue?vue&type=style&index=0&id=947cd7b6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "947cd7b6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
